import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { coordinateFields } from './common/coordinateFields';
import { msg } from '@lingui/core/macro';
import { volumeUnitField } from './common/sharedFields';

export const waterStorageMetadata = {
  displayName: msg({
    message: 'Water storage',
    context: 'Activity data schema name for water storage',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...buildingCommonFields,
    ...coordinateFields,
    ...buildingRevisionFields,
    quantity: {
      displayName: msg({
        message: 'Water stored',
        context: 'The quantity of water stored.',
      }),
      externalDescription: msg({
        message:
          'The quantity of water stored within organizational boundaries.',
        context: 'Water stored',
      }),
    },
    unit: volumeUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
